<template>
  <div style="width: 100%">
    <div class="pc_header">
      <div class="header">
        <div class="logo">
          <a href="" target="_blank">
            <img src="../../assets/img/home/logo.png" alt="" />
          </a>
        </div>
        <div class="top-menu">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#fff"
            text-color="#000"
            active-text-color="#000"
            @select="selectMenu"
          >
            <el-menu-item index="/home">
              <span slot="title">首页</span>
            </el-menu-item>
            <el-submenu index="2">
              <template slot="title">SaaS</template>
              <el-menu-item index="http://jd.demo.zhongpukeji.cn">外贸综合服务平台</el-menu-item>
              <el-menu-item index="/cloudSaaS1">SCM供应链管理系统</el-menu-item>
              <el-menu-item index="/cloudSaaS2">B2B电商交易系统</el-menu-item>
              <el-menu-item index="/cloudSaaS3">数字化采购管理系统</el-menu-item>
              <el-menu-item index="/cloudSaaS4">智慧风控系统</el-menu-item>
              <el-menu-item index="/cloudSaaS5">数据中台系统</el-menu-item>
            </el-submenu>
            <el-menu-item index="/futures">
              <span slot="title">数据</span>
            </el-menu-item>
            <el-menu-item index="/summit">
              <span slot="title">声音</span>
            </el-menu-item>
            <el-menu-item index="/about">
              <span slot="title">关于</span>
            </el-menu-item>
            <el-menu-item index="http://www.schome.vip/">
              <span slot="title">供应链之家</span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="header-btn">
          <template v-if="isLoggedIn">
            <el-dropdown trigger="click" @command="handleUserCommand">
              <span class="user-dropdown">
                <span class="user-avatar">{{ avatarInitial }}</span>
                <span class="user-name">{{ userInfo.nickname || userInfo.username || '用户' }}</span>
                <i class="el-icon-arrow-down"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="profile">
                  <i class="el-icon-user"></i> 个人中心
                </el-dropdown-item>
                <el-dropdown-item command="favorites">
                  <i class="el-icon-star-on"></i> 我的收藏
                </el-dropdown-item>
                <el-dropdown-item command="trial">
                  <i class="el-icon-s-promotion"></i> 试用申请
                </el-dropdown-item>
                <el-dropdown-item divided command="logout">
                  <i class="el-icon-switch-button"></i> 退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>
            <a class="login" @click.prevent="goLogin">登录</a>
            <a @click.prevent="goLogin">申请试用</a>
            <a class="login" href="http://iportal.zhongpukeji.cn/#/login">内部入口</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser, logout } from '../../utils/auth.js'
export default {
  data () {
    return {
      activeIndex: '/home',
      isLoggedIn: false,
      userInfo: {}
    }
  },
  computed: {
    avatarInitial () {
      const name = this.userInfo.nickname || this.userInfo.username || 'U'
      return name.slice(0, 1).toUpperCase()
    }
  },
  watch: {
    $route: 'routeHandle'
  },
  created () {
    this.routeHandle(this.$route)
    this.checkLoginStatus()
    // 监听登录成功事件，刷新头部登录状态
    this.$bus.$on('login-success', this.checkLoginStatus)
  },
  methods: {
    routeHandle (route) {
      this.activeIndex = route.path
      this.checkLoginStatus()
    },
    checkLoginStatus () {
      const user = getCurrentUser()
      this.isLoggedIn = !!user
      this.userInfo = user || {}
    },
    goLogin () {
      this.$bus.$emit('open-login')
    },
    handleUserCommand (command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          logout()
          this.isLoggedIn = false
          this.userInfo = {}
          this.$message.success('已退出登录')
        }).catch(() => {})
      } else {
        this.$router.push('/' + command)
      }
    },
    selectMenu (val) {
      if (val.includes('http')) {
        window.open(val)
      } else {
        this.$router.push({ path: val })
      }
    }
  },
  mounted () {
    // 监听登录状态变化
    window.addEventListener('storage', this.checkLoginStatus)
  },
  beforeDestroy () {
    window.removeEventListener('storage', this.checkLoginStatus)
    this.$bus.$off('login-success', this.checkLoginStatus)
  }
}
</script>

<style lang="scss">
.header-btn {
  padding-top: 22px;
  .login{
    background: #f5f5f5;
    color: #000;
  }
  a {
    display: inline-block;
    background: #000;
    color: #fff;
    padding: 8px 28px;
    border-radius: 20px;
    text-align: center;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
  }
  .user-dropdown {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 20px;
    background: #f5f5f5;
    transition: all 0.3s;

    &:hover {
      background: #eee;
    }

    .user-avatar {
      width: 28px;
      height: 28px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #fff;
      font-weight: bold;
      margin-right: 8px;
    }

    .user-name {
      font-size: 14px;
      color: #333;
      margin-right: 4px;
    }

    i {
      font-size: 12px;
      color: #999;
    }
  }
}
.pc_header {
  height: 70px;
  width: 100%;
  position: fixed;
  z-index: 2001;
  background: #fff;
}

.header {
  height: 70px;
  margin: auto;
  display: flex;
  .logo {
    width: 180px;
    height: 60px;
    padding: 10px 10px;
    img {
      height: 50px;
    }
  }
  .top-menu {
    flex: 1;
    display: flex;
    line-height: 70px;
    padding: 0 10px;
    font-size: 18px;
    letter-spacing: 2px;
    justify-content: left;
    overflow: hidden;
    .el-menu--horizontal>.el-submenu .el-submenu__title{
      padding: 6px 10px 0;
      height: 50px;
      line-height: 50px;
    }
    .el-menu-item{
      padding: 0 2px;
    }
    .el-menu--horizontal {
      border-bottom: none;
      .el-menu-item {
        margin: 20px 10px 0;
        height: 40px;
        line-height: 40px;
      }
      .el-submenu{
        padding-top: 10px;
        height: 40px;
      }

    }
    .el-menu-demo {
      .icon-svg {
        width: 18px;
        height: 18px;
        vertical-align: -0.3em;
        --primary-color: #aaa;
      }
      .is-active {
        .icon-svg {
          --primary-color: #000;
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .header {
    width: 100%;
    .top-menu{
      display: none;
    }
    .header-btn{
      display: none;
    }
  }
}

@media screen and (min-width: 1200px) {
  .header {
    width: 1200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/header.vue